import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MapChargeToBusinessSegmentFormComponent } from './map-charge-to-business-segment-form/map-charge-to-business-segment-form.component';
import { GstUpdateFormComponent } from './gst-update-form/gst-update-form.component';

const routes:Routes=[
  {
    path:'',
    data:{
      title:'Map Charge To Business Segment',
    },
    component:MapChargeToBusinessSegmentFormComponent
  },
  {
    path:'add',
    data:{
        title:'Add Map Charge To Business Segment',
    },
    component:MapChargeToBusinessSegmentFormComponent
  },
  {
      path:'edit/:id',
      data:{
          title:'Add Map Charge To Business Segment',
      },
      component:MapChargeToBusinessSegmentFormComponent
  },
  {
    path:'update/gst',
    data:{
      title:'Map Charge To Business Segment',
    },
    component:GstUpdateFormComponent
  }
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports:[RouterModule]
})
export class MapChargeToBusinessSegmentRoutingModule { }
